import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const url = config.url || "";
    // Admin endpoints use admin token
    if (url.startsWith("/admin") || url === "/auth/login" || url === "/auth/me" || url === "/auth/change-password") {
        const t = localStorage.getItem("hs_admin_token");
        if (t) config.headers.Authorization = `Bearer ${t}`;
    } else {
        // Customer-or-public endpoints: attach customer token if present
        const t = localStorage.getItem("hs_customer_token");
        if (t) config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            const url = err.config?.url || "";
            if (url.startsWith("/admin") || url.startsWith("/auth")) {
                localStorage.removeItem("hs_admin_token");
            } else if (url.startsWith("/customer")) {
                localStorage.removeItem("hs_customer_token");
            }
        }
        return Promise.reject(err);
    },
);

export default api;
